<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">All Journal Batches</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <AllBatchesTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Create Bank Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import AllBatchesTable from "../../components/Kleyton/Tables/Journal/AllBatchesTable";

export default {
  page: {
    title: "All Journals",
    meta: [{ name: "All Journals", content: window.__env.app.description }]
  },
  components: {
    AllBatchesTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "All Journals",

      items: [
        {
          text: "Journal",
          href: "/"
        },
        {
          text: "Create Journal",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
